import _orderBy from 'lodash/orderBy';
import { GIFTS_PRICES as SORTS } from '../constants/catalogs/giftsPrices';

export const addProductToProductsList = (
  newProduct,
  products,
  reverse = false
) => {
  let product = products.find(({ id }) => id === newProduct.id);

  if (product) {
    product.variant = newProduct.variant;
    product.quantity = newProduct.quantity;
  } else product = newProduct;

  const hasNewProduct = !products.some(({ id }) => id === newProduct.id);

  const mapProductsWithNewProduct = (currentProduct) => {
    const sameProduct = currentProduct.id === product.id;
    return sameProduct ? product : currentProduct;
  };

  const newProducts = products.map(mapProductsWithNewProduct);

  if (hasNewProduct) {
    if (reverse === true) {
      return [product, ...newProducts];
    }
    newProducts.push(product);
  }

  return newProducts;
};

export const deleteProductToProductsList = (product, products) => {
  const filteredProducts = products.filter(
    ({ id }) => id !== Number(product.id)
  );
  return filteredProducts;
};

export const getCleanProducts = (products) =>
  products.map((product) => ({
    quantity: product.quantity,
    id: product.id,
  }));

export const orderProductsByRule = (
  products,
  sortRule,
  originalProducts = null
) => {
  const RULES = {
    [SORTS.HIGHER_PRICE.value]: 'desc',
    [SORTS.LOWER_PRICE.value]: 'asc',
  };

  const sortBy = RULES[sortRule];

  if (!sortBy) return originalProducts || products;

  const orderProducts = _orderBy(products, ['price'], [sortBy]);

  return orderProducts;
};
